 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime~main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"banner":"banner","cards":"cards","common":"common","accordion":"accordion","caveats":"caveats","content-blocks":"content-blocks","fund-cards":"fund-cards","fund-compare":"fund-compare","fund-press-releases":"fund-press-releases","marketo-form":"marketo-form","cta-banner":"cta-banner","datadog":"datadog","dynamic-cards":"dynamic-cards","image-grid":"image-grid","interactive-content":"interactive-content","link-list":"link-list","Latest Dividends":"Latest Dividends","tax":"tax","vendor.async.ng2-pdfjs-viewer":"vendor.async.ng2-pdfjs-viewer","literature":"literature","njbest-treasurry-managed-layout":"njbest-treasurry-managed-layout","on-page-search":"on-page-search","profile":"profile","role-selector-cards":"role-selector-cards","fund-attribution":"fund-attribution","morningstar-table":"morningstar-table","product-detail-layout":"product-detail-layout","product-details":"product-details","section-nav":"section-nav","table-with-filters":"table-with-filters","us-index":"us-index","vendor.async.xlsx":"vendor.async.xlsx","article":"article","german-calculator-one-time-investment":"german-calculator-one-time-investment","german-calculator-pension":"german-calculator-pension","german-calculator-savings-plan":"german-calculator-savings-plan","german-calculator-withdrawl-plan":"german-calculator-withdrawl-plan","australia-fund-platforms":"australia-fund-platforms","njbest-get-started":"njbest-get-started","njbest-portfolio-selector":"njbest-portfolio-selector","retirement-lifestyle-tool":"retirement-lifestyle-tool","us-index-allocations":"us-index-allocations","us-index-banner":"us-index-banner","us-index-performance":"us-index-performance","what-happened-last-week":"what-happened-last-week","cpreif-location-map":"cpreif-location-map","cpreif-portfolio-tool":"cpreif-portfolio-tool","dynamic-dropdown-tool":"dynamic-dropdown-tool","fixed-income-fine-tuning":"fixed-income-fine-tuning","effective-annual-costs":"effective-annual-costs","literature-audit":"literature-audit","munimap":"munimap","news-feeds-tool":"news-feeds-tool","njbest-investment-options":"njbest-investment-options","pcstool":"pcstool","popquiz":"popquiz","vendor.async.html2canvas":"vendor.async.html2canvas","mifid-calculator":"mifid-calculator","njbest-treasury-managed-price-and-performance":"njbest-treasury-managed-price-and-performance","us-index-top-constituents":"us-index-top-constituents","vendor.async.gaugeJS":"vendor.async.gaugeJS","recession-dashboard":"recession-dashboard","njbest-contribution-calculator":"njbest-contribution-calculator","quotential-questionnaire":"quotential-questionnaire","simple-highcharts":"simple-highcharts"}[chunkId]||chunkId) + "-es2015." + {"0":"22c5e792d54b02884d5b","banner":"befb7b5786392e29a44b","cards":"41dafcc86e4b8dc67c9f","common":"0a90cb3f046a93c0c2c9","accordion":"d180788614210f638994","caveats":"00bf4a00e9be076ecad8","content-blocks":"4309f082f9ffcaaa1d44","fund-cards":"079f78034d95b13a0001","fund-compare":"ea58f645d8cc4895810b","fund-press-releases":"9467bccef7def1c41674","marketo-form":"160ff1ba576ea060709e","cta-banner":"352811ea05a35e1663b0","datadog":"88afdd97cb608b01a655","dynamic-cards":"00f8ccfc91896a0a0298","image-grid":"7697a81f30a9c56b8af4","interactive-content":"e1d4fd3ad2670360a9e3","link-list":"bf274d61aeb0fd6adef1","Latest Dividends":"a86b34317dd83e5833c5","tax":"c4de8640e3738a713b9f","vendor.async.ng2-pdfjs-viewer":"77dfe9f7ae2c0aa9130d","literature":"89ac142058d30c27e5df","njbest-treasurry-managed-layout":"c4a42482c050ab735abd","on-page-search":"45e42f748d3c5415a6d1","profile":"5134dabb25275e4c6b69","role-selector-cards":"1983e836b0f5765e6bd8","fund-attribution":"c508f398e83208644538","morningstar-table":"2064ffe44e8523f87475","product-detail-layout":"b51d02b17a4e774c679c","product-details":"b36f45b4cb6f90d4409d","section-nav":"86bddc771a8f4b95db4a","table-with-filters":"e1ed676ca633fef5339a","us-index":"f555a83e357b3ea3ec6a","vendor.async.xlsx":"1c293854145bccbf7452","article":"2b5795b783c853a02dc6","german-calculator-one-time-investment":"acd58e983d90e1df63e5","german-calculator-pension":"e86bd1a3a5fd58bb31ca","german-calculator-savings-plan":"9707c06ac1e64b15bbbf","german-calculator-withdrawl-plan":"09506dae4073ec2c501b","australia-fund-platforms":"6f594b989386e32c7c3e","njbest-get-started":"0026ec678cd771b3b6ad","njbest-portfolio-selector":"1666af37ded4d67ae966","retirement-lifestyle-tool":"023a528d3fc4ad796e12","us-index-allocations":"074079d8b3ea8490ea99","us-index-banner":"e4faa3cd2f309251ca67","us-index-performance":"2133aa6d2e360bc2228f","what-happened-last-week":"85b5a482308a1c80c3cb","cpreif-location-map":"4e06b608462afd742867","cpreif-portfolio-tool":"29f15622e1c153e6fc83","dynamic-dropdown-tool":"2dde7572c70ea5e3cdc4","fixed-income-fine-tuning":"a76c1ed41e042d9bd43b","effective-annual-costs":"ef7f14aaf80e5d38f462","literature-audit":"426bcb1f3e7abc093079","munimap":"d6367f6f44ea7687d633","news-feeds-tool":"7d854ded80a857b7a06d","njbest-investment-options":"1bff102505016d060889","pcstool":"1bef2325f5d3c2a278b4","popquiz":"5564e3ae0a83edb3a5d4","vendor.async.html2canvas":"f29a7ceddb9474285e00","mifid-calculator":"5ea0f2c478be058fcbde","njbest-treasury-managed-price-and-performance":"9a309c0d96aeeef1f9db","us-index-top-constituents":"cf5a7e400fcb1ce11acd","vendor.async.gaugeJS":"ea9e8c90ca4f79ce542e","recession-dashboard":"1a67eab904f04f667c19","njbest-contribution-calculator":"b6db7704170529d4d915","quotential-questionnaire":"1b5435c51e6a030fef6e","simple-highcharts":"26f10c46f6b05e0a42d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
